import React from "react";

const FeatureCards = ({ cardsData, cardsStyling = "" }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      {cardsData.map((card, index) => {
        return (
          <div
            key={index}
            className={`flex flex-col gap-6 border-2 px-6 sm:px-10 pb-10 pt-16 rounded-xl cardBorders transition-all duration-500 ease-in-out border-gray-600 text-center ${card.styling}`}
          >
            <div className="flex items-center justify-center w-[100px] h-[100px] mx-auto">
              {card.icon && (
                <div className="text-5xl lg:text-5xl flex justify-center items-center h-full w-full bg-white rounded-full">
                  {card.icon}
                </div>
              )}
            </div>
            <div className="flex flex-col gap-4">
              <h3 className="text-2xl font-bold">{card.title}</h3>
              <p className="text-xl">{card.description}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FeatureCards;
